import * as tslib_1 from "tslib";
import { OnDestroy } from '@angular/core';
import { CpAgGridService } from '@app/Modules/cp-grid/services/cp-ag-grid-service';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '@app/Modules/Shared/Services/app.service';
import { MyProfileService } from '@app/Modules/my-profile/Components/services/my-profile-service';
import { MessageService } from 'primeng/api';
import { GlobalAppService } from '@app/Modules/Shared/Services/global-app.service';
import { HttpInvoicePriceService } from '@app/Modules/Shared/Services/http-invoice-price.service';
import { InvoicePriceService } from '@app/Modules/in-voice/Services/invoice-price.service';
import { environment } from '@env/environment';
var CpColumnHeaderComponent = /** @class */ (function () {
    function CpColumnHeaderComponent(router, activatedRoute, gridService, appServ, globalAppService, messageService, myProfileService, httpInvoiceService, invoicePriceService) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.gridService = gridService;
        this.appServ = appServ;
        this.globalAppService = globalAppService;
        this.messageService = messageService;
        this.myProfileService = myProfileService;
        this.httpInvoiceService = httpInvoiceService;
        this.invoicePriceService = invoicePriceService;
        this.subscription = new Subscription();
        this.ifHovered = false;
        this.gridOptions = {};
        this.checkboxStatus = '';
        this.addToPrefCheckBoxStatus = false;
        this.headerCheckBoxStatusPA = false;
        this.headerCheckBoxStatusMC = false;
        this.headerCheckBoxStatusCB = false;
        this.headerCheckBoxStatusIN = false;
        this.headerCheckBoxStatusOD = false;
        this.isMyProfileInternal = false;
        this.partialCheckBoxStatus = false;
        this.partialPACheckBoxStatus = false;
        this.tolltipHoverClass = "tooltip-hover";
        this.isGlobalUser = false;
        this.ufnDisabled = false;
        this.efileManageErrorColumnIds = ['reF_NUM', 'custloc', 'd_BRANCH', 'item_NBR', 'kC_ENDU', 'eU_NME', 'shtO_NBR', 'shtO_NME', 'shtO_AD1', 'shtO_AD2', 'shtO_CTY', 'shtO_ST', 'shtO_ZIP', 'shtO_CTRY', 'proD_ID', 'd_PROD', 'invC_DTE', 'invC_NBR', 'cases', 'unT_MSR', 'itW_PRC', 'pA_PRC', 'exT_RBT', 'pA_NBR', 'hierarchy', 'bilL_TO_NBR', 'bilL_TO_NME', 'gpO_ID', "clM_EN_DTE", "clM_ST_DTE", "curr", "invC_TOT_AMT", "d_PA_PRC", "d_ITW_PRC", "vaL_FRM", "vaL_TO", "kC_PA_PRC", "kC_ITW_PRC", "kC_EXT_RBT", "d_EXT_RBT", "diff", "observ", "proD_DESC", "taX_ID"];
        this.showEfileErrorColumnToolTip = {};
        this.invoicePriceColumnIds = ['lastRefreshDate_invoice', 'refreshStatus_invoice', 'nextAvailableDate_invoice'];
        this.shownIvoicePriceColumnToolTip = {};
        this.isPageInvoiceRecentRequest = false;
        this.gridName = "";
        if (this.router.url.indexOf('profile/myprofile') > -1) {
            this.isMyProfileInternal = true;
        }
    }
    CpColumnHeaderComponent.prototype.agInit = function (params) {
        this.params = params;
        this.isEfileManageErrorColumnId(params.column.colId);
        if (params.column.colId == 'customerNumber_invoice' || params.column.colId == 'lastRefreshDate_invoice' || params.column.colId == 'refreshStatus_invoice' || params.column.colId == 'nextAvailableDate_invoice') {
            this.isInvoicePriceColumnId(params.column.colId);
        }
        // this.subscription.add(this.languageServ.currentSelected.subscribe((language) => {
        //     this.translateServ.setDefaultLang(language.regionCode);
        // }));
        params.column.addEventListener('sortChanged', this.onSortChanged.bind(this));
        this.onSortChanged();
        this.params.api.forEachNode(function (node) {
            if (node.data && node.data._cpCheckbox === false) {
            }
        });
        if (!this.checkboxName) {
            this.checkboxName = Math.random().toString(36).substring(2, 15);
        }
    };
    CpColumnHeaderComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subscription.add(this.gridService.getRowCheckboxSelection().subscribe(function (data) {
            _this.checkboxStatus = data;
            _this.isAllFavorite = _this.checkFavIconSelectionStatus();
        }));
        this.isInternalUser = this.appServ.isInternalUser;
        this.region = this.globalAppService.getDefaultRegionString();
        if (this.region == 'EMEA') {
            this.ufnDisabled = environment.ufnDisabled;
        }
        //Column my profile PA Header checkbox
        this.subscription.add(this.gridService.getnodeMyProfilePASelectAll().subscribe(function (data) {
            switch (data) {
                case "ALL":
                    _this.headerCheckBoxStatusPA = true;
                    break;
                case "NONE":
                    _this.headerCheckBoxStatusPA = false;
                    break;
            }
        }));
        //Column my profile Meet comp Header checkbox
        this.subscription.add(this.gridService.getnodeMyProfileMCSelectAll().subscribe(function (data) {
            switch (data) {
                case "ALL":
                    _this.headerCheckBoxStatusMC = true;
                    break;
                case "NONE":
                    _this.headerCheckBoxStatusMC = false;
                    break;
            }
        }));
        //Column my profile Charge back Header checkbox
        this.subscription.add(this.gridService.getnodeMyProfileCBSelectAll().subscribe(function (data) {
            switch (data) {
                case "ALL":
                    _this.headerCheckBoxStatusCB = true;
                    break;
                case "NONE":
                    _this.headerCheckBoxStatusCB = false;
                    break;
            }
        }));
        //Column my profile Invoices Header checkbox
        this.subscription.add(this.gridService.getnodeMyProfileINSelectAll().subscribe(function (data) {
            switch (data) {
                case "ALL":
                    _this.headerCheckBoxStatusIN = true;
                    break;
                case "NONE":
                    _this.headerCheckBoxStatusIN = false;
                    break;
            }
        }));
        //Column my profile Orders Header checkbox
        this.subscription.add(this.gridService.getnodeMyProfileODSelectAll().subscribe(function (data) {
            switch (data) {
                case "ALL":
                    _this.headerCheckBoxStatusOD = true;
                    break;
                case "NONE":
                    _this.headerCheckBoxStatusOD = false;
                    break;
            }
        }));
        this.subscription.add(this.invoicePriceService.getUpdateFavColHeader().subscribe(function (update) {
            if (update) {
                _this.isAllFavorite = _this.checkFavIconSelectionStatus();
            }
        }));
        this.isGlobalUser = this.appServ.isGlobalUser;
        if (this.gridService.pageContext && this.gridService.pageContext.pageName && this.gridService.pageContext.pageName == 'recentRequests') {
            this.isPageInvoiceRecentRequest = true;
        }
        this.gridService.getGridLoaded().subscribe(function (gridLoaded) {
            if (_this.gridService.pageContext && _this.gridService.pageContext.pageName) {
                _this.gridName = _this.gridService.pageContext.pageName;
            }
        });
    };
    CpColumnHeaderComponent.prototype.onMenuClicked = function () {
        this.params.showColumnMenu(this.menuButton.nativeElement);
    };
    ;
    CpColumnHeaderComponent.prototype.onCellMouseOver = function () {
        this.ifHovered = true;
    };
    CpColumnHeaderComponent.prototype.onCellMouseOut = function () {
        this.ifHovered = false;
    };
    CpColumnHeaderComponent.prototype.onSortRequested = function (order, event) {
        this.params.setSort(order, event.shiftKey);
    };
    CpColumnHeaderComponent.prototype.onSortChanged = function () {
        this.ascSort = this.descSort = this.noSort = 'inactive';
        if (this.params.column.isSortAscending()) {
            this.ascSort = 'active';
        }
        else if (this.params.column.isSortDescending()) {
            this.descSort = 'active';
        }
        else {
            this.noSort = 'active';
        }
    };
    CpColumnHeaderComponent.prototype.selectAllNodes = function (event) {
        // this.checkboxStatus = event.target.checked;
        var startRowIndex = this.params.api.getFirstDisplayedRow();
        var lastRowIndex = this.params.api.getLastDisplayedRow();
        if (lastRowIndex >= 0) {
            for (var ctr = startRowIndex; ctr <= lastRowIndex; ctr++) {
                if (this.region.toUpperCase() == 'EMEA') {
                    if (this.params.api.getDisplayedRowAtIndex(ctr).data.status != "PD" &&
                        this.params.api.getDisplayedRowAtIndex(ctr).data.status != "Pending" &&
                        this.params.api.getDisplayedRowAtIndex(ctr).data.status != "B" &&
                        this.params.api.getDisplayedRowAtIndex(ctr).data.status != "Denied" &&
                        this.params.api.getDisplayedRowAtIndex(ctr).data.refreshStatus != 1) {
                        this.params.api.getDisplayedRowAtIndex(ctr).setSelected(event.target.checked);
                    }
                }
                else {
                    if (this.params.api.getDisplayedRowAtIndex(ctr).data.status != "PD" &&
                        this.params.api.getDisplayedRowAtIndex(ctr).data.status != "Pending" &&
                        this.params.api.getDisplayedRowAtIndex(ctr).data.refreshStatus != 1) {
                        this.params.api.getDisplayedRowAtIndex(ctr).setSelected(event.target.checked);
                    }
                }
            }
        }
    };
    CpColumnHeaderComponent.prototype.selectAllNodesAddToPref = function (event) {
        var _this = this;
        this.appServ.setLoadingStatus(true);
        this.addToPrefCheckBoxStatus = event.target.checked;
        if (this.region == "EMEA" && !this.addToPrefCheckBoxStatus) {
            this.setCheckboxStatus("PACheckBoxHeader", this.addToPrefCheckBoxStatus);
            this.setCheckboxStatus("CBCheckBoxHeader", this.addToPrefCheckBoxStatus);
        }
        else if (this.region == "LAO" && !this.addToPrefCheckBoxStatus) {
            this.setCheckboxStatus("PACheckBoxHeader", this.addToPrefCheckBoxStatus);
            this.setCheckboxStatus("CBCheckBoxHeader", this.addToPrefCheckBoxStatus);
        }
        else if (this.region == "NA" && !this.addToPrefCheckBoxStatus) {
            this.setCheckboxStatus("PACheckBoxHeader", this.addToPrefCheckBoxStatus);
            this.setCheckboxStatus("MCCheckBoxHeader", this.addToPrefCheckBoxStatus);
            this.setCheckboxStatus("CBCheckBoxHeader", this.addToPrefCheckBoxStatus);
            this.setCheckboxStatus("INCheckBoxHeader", this.addToPrefCheckBoxStatus);
            this.setCheckboxStatus("ODCheckBoxHeader", this.addToPrefCheckBoxStatus);
        }
        else if (this.region == "APAC" && !this.addToPrefCheckBoxStatus) {
            this.setCheckboxStatus("PACheckBoxHeader", this.addToPrefCheckBoxStatus);
            this.setCheckboxStatus("CBCheckBoxHeader", this.addToPrefCheckBoxStatus);
        }
        this.gridService.gridApi.forEachNode(function (node) {
            node.data.isDefault = event.target.checked;
            _this.setCheckboxStatus("ATP-" + node.data.customerNumber, _this.addToPrefCheckBoxStatus);
            /** If unselect all, do not set checked to false for default location's checkbox so,
             * when you check the add to pref one by one at that time after clicking on last item
             * make the header checkbox should get checked
             * */
            if (!_this.addToPrefCheckBoxStatus && node.data.customerNumber == _this.myProfileService.getPreveiousSelectedLoc()) {
                _this.setCheckboxStatus("ATP-" + node.data.customerNumber, true);
                node.data.isDefault = true;
            }
            var isDfaultLocationMatching = node.data.customerNumber == _this.myProfileService.getPreveiousSelectedLoc();
            /** Update the dailly mails Prefernces object and checkstatus except default location's*/
            if (_this.region == "EMEA" && !_this.addToPrefCheckBoxStatus && !isDfaultLocationMatching) {
                node.data.Preferences[0].isSelected = event.target.checked;
                _this.setCheckboxStatus("PA-" + node.data.customerNumber, _this.addToPrefCheckBoxStatus);
                node.data.Preferences[1].isSelected = event.target.checked;
                _this.setCheckboxStatus("CB-" + node.data.customerNumber, _this.addToPrefCheckBoxStatus);
            }
            else if (_this.region == "LAO" && !_this.addToPrefCheckBoxStatus && !isDfaultLocationMatching) {
                node.data.Preferences[0].isSelected = event.target.checked;
                _this.setCheckboxStatus("PA-" + node.data.customerNumber, _this.addToPrefCheckBoxStatus);
                node.data.Preferences[1].isSelected = event.target.checked;
                _this.setCheckboxStatus("CB-" + node.data.customerNumber, _this.addToPrefCheckBoxStatus);
            }
            else if (_this.region == "NA" && !_this.addToPrefCheckBoxStatus && !isDfaultLocationMatching) {
                node.data.Preferences[0].isSelected = event.target.checked;
                _this.setCheckboxStatus("PA-" + node.data.customerNumber, _this.addToPrefCheckBoxStatus);
                node.data.Preferences[1].isSelected = event.target.checked;
                _this.setCheckboxStatus("MC-" + node.data.customerNumber, _this.addToPrefCheckBoxStatus);
                node.data.Preferences[2].isSelected = event.target.checked;
                _this.setCheckboxStatus("CB-" + node.data.customerNumber, _this.addToPrefCheckBoxStatus);
                node.data.Preferences[3].isSelected = event.target.checked;
                _this.setCheckboxStatus("IN-" + node.data.customerNumber, _this.addToPrefCheckBoxStatus);
                node.data.Preferences[4].isSelected = event.target.checked;
                _this.setCheckboxStatus("OD-" + node.data.customerNumber, _this.addToPrefCheckBoxStatus);
            }
            else if (_this.region == "APAC" && !_this.addToPrefCheckBoxStatus && !isDfaultLocationMatching) {
                node.data.Preferences[0].isSelected = event.target.checked;
                _this.setCheckboxStatus("PA-" + node.data.customerNumber, _this.addToPrefCheckBoxStatus);
                node.data.Preferences[1].isSelected = event.target.checked;
                _this.setCheckboxStatus("CB-" + node.data.customerNumber, _this.addToPrefCheckBoxStatus);
            }
        });
        setTimeout(function () {
            _this.appServ.setLoadingStatus(false);
        }, 500);
    };
    CpColumnHeaderComponent.prototype.setCheckboxStatus = function (checkboxName, status) {
        var el = document.getElementById(checkboxName);
        if (el) {
            el.checked = status;
        }
    };
    CpColumnHeaderComponent.prototype.selectAllNodesMyProfilePA = function (event) {
        var _this = this;
        this.headerCheckBoxStatusPA = event.target.checked;
        if (this.headerCheckBoxStatusPA) {
            this.setCheckboxStatus("addToPrefCheckBoxHeader", this.headerCheckBoxStatusPA);
        }
        console.log('this.gridService.gridApiiiiiii', this.gridService.gridApi);
        this.gridService.gridApi.forEachNode(function (node) {
            if (node.data && node.data.customerNumber) {
                console.log('node.dataaaaa', node.data);
                node.data.Preferences.find(function (x) {
                    return x.moduleId == 1;
                }).isSelected = event.target.checked;
            }
            if (_this.headerCheckBoxStatusPA && !_this.isInternalUser) {
                node.data.isDefault = event.target.checked;
                _this.setCheckboxStatus("ATP-" + node.data.customerNumber, _this.headerCheckBoxStatusPA);
            }
        });
        if (this.isInternalUser) {
            this.gridService.setMyProfilePASelectAll(this.headerCheckBoxStatusPA);
        }
        else {
            this.gridService.gridApi.forEachNode(function (node) {
                if (node && node.data && node.data.Preferences[0]) {
                    node.data.Preferences[0].isSelected = event.target.checked;
                    _this.setCheckboxStatus("PA-" + node.data.customerNumber, _this.headerCheckBoxStatusPA);
                }
            });
        }
    };
    CpColumnHeaderComponent.prototype.selectAllNodesMyProfileMC = function (event) {
        var _this = this;
        this.headerCheckBoxStatusMC = event.target.checked;
        if (this.headerCheckBoxStatusMC) {
            this.setCheckboxStatus("addToPrefCheckBoxHeader", this.headerCheckBoxStatusMC);
        }
        this.gridService.gridApi.forEachNode(function (node) {
            if (node.data && node.data.customerNumber) {
                node.data.Preferences.find(function (x) {
                    return x.moduleId == 2;
                }).isSelected = event.target.checked;
                if (_this.headerCheckBoxStatusMC && !_this.isInternalUser) {
                    node.data.isDefault = event.target.checked;
                    _this.setCheckboxStatus("ATP-" + node.data.customerNumber, _this.headerCheckBoxStatusMC);
                }
            }
        });
        if (this.isInternalUser) {
            this.gridService.setMyProfileMCSelecAll(this.headerCheckBoxStatusMC);
        }
        else {
            this.gridService.gridApi.forEachNode(function (node) {
                node.data.Preferences[1].isSelected = event.target.checked;
                _this.setCheckboxStatus("MC-" + node.data.customerNumber, _this.headerCheckBoxStatusMC);
            });
        }
    };
    CpColumnHeaderComponent.prototype.selectAllNodesMyProfileCB = function (event) {
        var _this = this;
        this.headerCheckBoxStatusCB = event.target.checked;
        if (this.headerCheckBoxStatusCB) {
            this.setCheckboxStatus("addToPrefCheckBoxHeader", this.headerCheckBoxStatusCB);
        }
        this.gridService.gridApi.forEachNode(function (node) {
            if (node.data && node.data.customerNumber) {
                node.data.Preferences.find(function (x) {
                    return x.moduleId == 3;
                }).isSelected = event.target.checked;
                if (_this.headerCheckBoxStatusCB && !_this.isInternalUser) {
                    node.data.isDefault = event.target.checked;
                    _this.setCheckboxStatus("ATP-" + node.data.customerNumber, _this.headerCheckBoxStatusCB);
                }
            }
        });
        if (this.isInternalUser) {
            this.gridService.setMyProfileCBSelecAll(this.headerCheckBoxStatusCB);
        }
        else {
            this.gridService.gridApi.forEachNode(function (node) {
                if (node && node.data && (node.data.regionId != "EMEA" && node.data.regionId != "LAO" && node.data.regionId != "APAC") && node.data.Preferences[2]) {
                    node.data.Preferences[2].isSelected = event.target.checked;
                    _this.setCheckboxStatus("CB-" + node.data.customerNumber, _this.headerCheckBoxStatusCB);
                }
                else if (node && node.data && (node.data.regionId == "EMEA" || node.data.regionId == "LAO" || node.data.regionId == "APAC") && node.data.Preferences[1]) {
                    node.data.Preferences[1].isSelected = event.target.checked;
                    _this.setCheckboxStatus("CB-" + node.data.customerNumber, _this.headerCheckBoxStatusCB);
                }
            });
        }
    };
    CpColumnHeaderComponent.prototype.selectAllNodesMyProfileIN = function (event) {
        var _this = this;
        this.headerCheckBoxStatusIN = event.target.checked;
        if (this.headerCheckBoxStatusIN) {
            this.setCheckboxStatus("addToPrefCheckBoxHeader", this.headerCheckBoxStatusIN);
        }
        this.gridService.gridApi.forEachNode(function (node) {
            if (node.data && node.data.customerNumber) {
                node.data.Preferences.find(function (x) {
                    return x.moduleId == 4;
                }).isSelected = event.target.checked;
                if (_this.headerCheckBoxStatusIN && !_this.isInternalUser) {
                    node.data.isDefault = event.target.checked;
                    _this.setCheckboxStatus("ATP-" + node.data.customerNumber, _this.headerCheckBoxStatusIN);
                }
            }
        });
        if (this.isInternalUser) {
            this.gridService.setMyProfileINSelecAll(this.headerCheckBoxStatusIN);
        }
        else {
            this.gridService.gridApi.forEachNode(function (node) {
                node.data.Preferences[3].isSelected = event.target.checked;
                _this.setCheckboxStatus("IN-" + node.data.customerNumber, _this.headerCheckBoxStatusIN);
            });
        }
    };
    CpColumnHeaderComponent.prototype.selectAllNodesMyProfileOD = function (event) {
        var _this = this;
        this.headerCheckBoxStatusOD = event.target.checked;
        if (this.headerCheckBoxStatusOD) {
            this.setCheckboxStatus("addToPrefCheckBoxHeader", this.headerCheckBoxStatusOD);
        }
        this.gridService.gridApi.forEachNode(function (node) {
            if (node.data && node.data.customerNumber) {
                node.data.Preferences.find(function (x) {
                    return x.moduleId == 5;
                }).isSelected = event.target.checked;
                if (_this.headerCheckBoxStatusOD && !_this.isInternalUser) {
                    node.data.isDefault = event.target.checked;
                    _this.setCheckboxStatus("ATP-" + node.data.customerNumber, _this.headerCheckBoxStatusOD);
                }
            }
        });
        if (this.isInternalUser) {
            this.gridService.setMyProfileODSelecAll(this.headerCheckBoxStatusOD);
        }
        else {
            this.gridService.gridApi.forEachNode(function (node) {
                node.data.Preferences[4].isSelected = event.target.checked;
                _this.setCheckboxStatus("OD-" + node.data.customerNumber, _this.headerCheckBoxStatusOD);
            });
        }
    };
    CpColumnHeaderComponent.prototype.displayLocationmodal = function () {
        this.router.navigate([{ outlets: { dialogs: ['locationSearch'] } }], { queryParamsHandling: 'preserve', relativeTo: this.activatedRoute.parent });
    };
    CpColumnHeaderComponent.prototype.showChangeGroupModal = function (isChangeGroup) {
        this.gridApi = this.gridService.gridApi;
        var selectedRows = this.gridApi.getSelectedRows();
        var defaultLocation = this.globalAppService.getDefaultProfileLocation();
        for (var selectedLocationIndex = 0; selectedLocationIndex <= selectedRows.length - 1; selectedLocationIndex++) {
            if (selectedRows[selectedLocationIndex].customerNumber == defaultLocation) {
                selectedRows.splice(selectedLocationIndex, 1);
            }
        }
        console.log("@@@ Selected Rows: ", selectedRows);
        if (selectedRows && selectedRows.length) {
            this.router.navigate([{ outlets: { dialogs: ['selectGroup'] } }], {
                queryParamsHandling: 'preserve', relativeTo: this.activatedRoute.parent,
                state: { isChangeGroup: isChangeGroup, selectedRows: selectedRows }
            });
        }
        else {
            this.messageService.clear();
            this.messageService.add({ key: 'locationError', severity: 'error', summary: 'messageText.selectLocationError.header', detail: 'messageText.selectLocationError.text' });
        }
    };
    CpColumnHeaderComponent.prototype.removeSelectedLocations = function () {
        this.gridApi = this.gridService.gridApi;
        var selectedRows = this.gridApi.getSelectedRows();
        this.myProfileService.setSelectedLocations(selectedRows);
    };
    CpColumnHeaderComponent.prototype.showTooltip = function (event) {
        this.tolltipHoverClass = this.gridService.getTooltipHoverClass(event);
    };
    CpColumnHeaderComponent.prototype.addRemoveFav = function (isFav) {
        var startRowIndex = this.params.api.getFirstDisplayedRow();
        var lastRowIndex = this.params.api.getLastDisplayedRow();
        var categoryList = [];
        if (lastRowIndex >= 0) {
            for (var ctr = startRowIndex; ctr <= lastRowIndex; ctr++) {
                var rowData = this.params.api.getDisplayedRowAtIndex(ctr).data;
                var obj = {
                    categoryCode: rowData.categoryCode,
                    isFavorite: isFav
                };
                categoryList.push(obj);
            }
            this.setOrRemoveFavoriteHttpCall(categoryList);
        }
    };
    CpColumnHeaderComponent.prototype.setOrRemoveFavoriteHttpCall = function (categoryList) {
        var _this = this;
        this.appServ.setLoadingStatus(true);
        var request = {
            userId: this.appServ.getuserId(false),
            favoriteCategoryList: categoryList
        };
        this.httpInvoiceService.saveFavoriteInvoiceCategory(request).subscribe(function (res) {
            if (res.statusMessage == "Success") {
                _this.invoicePriceService.setRedrawAdvancedGridRow(categoryList);
            }
        }, function () {
        }, function () {
            _this.appServ.setLoadingStatus(false);
        });
    };
    CpColumnHeaderComponent.prototype.checkFavIconSelectionStatus = function () {
        var startRowIndex = this.params.api.getFirstDisplayedRow();
        var lastRowIndex = this.params.api.getLastDisplayedRow();
        if (lastRowIndex >= 0) {
            for (var ctr = startRowIndex; ctr <= lastRowIndex; ctr++) {
                if (this.params.api.getDisplayedRowAtIndex(ctr).data && !this.params.api.getDisplayedRowAtIndex(ctr).data.isFavorite)
                    return false;
            }
            return true;
        }
        return true;
    };
    CpColumnHeaderComponent.prototype.openOrderPreferencePopup = function () {
        this.router.navigate([{ outlets: { dialogs: ['orderPreferences'] } }], { relativeTo: this.activatedRoute.parent, queryParamsHandling: "preserve" });
    };
    CpColumnHeaderComponent.prototype.isEfileManageErrorColumnId = function (id) {
        this.showEfileErrorColumnToolTip[id] = this.efileManageErrorColumnIds.indexOf(id) > -1;
    };
    CpColumnHeaderComponent.prototype.isInvoicePriceColumnId = function (id) {
        this.shownIvoicePriceColumnToolTip[id] = this.invoicePriceColumnIds.indexOf(id) > -1;
    };
    CpColumnHeaderComponent.prototype.ngOnDestroy = function () {
        //Destroying component
    };
    CpColumnHeaderComponent = tslib_1.__decorate([
        AutoUnsubscribe(),
        tslib_1.__metadata("design:paramtypes", [Router,
            ActivatedRoute,
            CpAgGridService,
            AppService,
            GlobalAppService,
            MessageService,
            MyProfileService,
            HttpInvoicePriceService,
            InvoicePriceService])
    ], CpColumnHeaderComponent);
    return CpColumnHeaderComponent;
}());
export { CpColumnHeaderComponent };
